import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import linkedin from "../assets/social/linkedin.png";
import twitter from "../assets/social/twitter.png";
import github from "../assets/social/github.png";
import peerlist from "../assets/social/Peerlist.png";
import contra from "../assets/social/contra.png";

/* ═══════════════════════════════════════════════════════════
   CONTACT — Luxury Form
   Gold hairline inputs · magnetic submit · social row
   ═══════════════════════════════════════════════════════════ */

const socials = [
  { name: "GitHub", url: "https://github.com/devsagarkhatri", icon: github },
  { name: "Twitter", url: "https://twitter.com/DevSagarKhatri", icon: twitter },
  { name: "LinkedIn", url: "https://www.linkedin.com/in/sagarkhatri/", icon: linkedin },
  { name: "Contra", url: "https://contra.com/devsagarkhatri", icon: contra },
  { name: "Peerlist", url: "https://peerlist.io/devsagarkhatri", icon: peerlist },
];

const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: form.name,
          to_name: "Email via Portfolio",
          from_email: form.email,
          to_email: "dev.sagarkhatri@gmail.com",
          message: form.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setLoading(false);
          alert("Thank you. I will get back to you as soon as possible.");
          setForm({ name: "", email: "", message: "" });
        },
        (error) => {
          setLoading(false);
          console.error(error);
          alert("Ahh, something went wrong. Please try again.");
        }
      );
  };

  return (
    <div className="lux-container">
      <div className="max-w-3xl mb-20">
        <p className="lux-eyebrow mb-6">Get in touch</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Contact</span>
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
        {/* Form */}
        {/* <div className="lg:col-span-3">
          <form
            ref={formRef}
            onSubmit={handleSubmit}
            className="space-y-8"
          >
            <div>
              <label className="block font-grotesk text-xs tracking-[0.2em] uppercase text-silver-400 mb-3">
                Your Name
              </label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="What's your good name?"
                className="lux-input"
                required
              />
            </div>

            <div>
              <label className="block font-grotesk text-xs tracking-[0.2em] uppercase text-silver-400 mb-3">
                Your Email
              </label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="What's your web address?"
                className="lux-input"
                required
              />
            </div>

            <div>
              <label className="block font-grotesk text-xs tracking-[0.2em] uppercase text-silver-400 mb-3">
                Your Message
              </label>
              <textarea
                rows={6}
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="What you want to say?"
                className="lux-input resize-none"
                required
              />
            </div>

            <button
              type="submit"
              className="lux-btn"
              data-magnetic="0.3"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Message"}
              {!loading && <span aria-hidden="true">→</span>}
            </button>
          </form>
        </div> */}

        {/* Socials */}
        <div className="lg:col-span-2 space-y-8">
          <div className="lux-card reveal-fade p-8">
            <h3 className="font-grotesk text-sm tracking-[0.2em] uppercase text-silver-200 mb-8">
              Drop a mail
            </h3>
            <div className="space-y-4">
              <a
                href="mailto:dev.sagarkhatri@gmail.com"
                className="flex items-center gap-4 group"
              >
                <span className="text-champagne-500 text-lg" aria-hidden="true">
                  ✉
                </span>
                <span className="font-grotesk text-sm text-silver-400 group-hover:text-champagne-300 transition-colors duration-500 break-all">
                  dev.sagarkhatri@gmail.com
                </span>
              </a>
             
            </div>
          </div>

          <div className="lux-card reveal-fade p-8">
            <h3 className="font-grotesk text-sm tracking-[0.2em] uppercase text-silver-200 mb-8">
              Connect with me
            </h3>
            <div className="space-y-4">
              {socials.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-4 group"
                >
                  <img
                    src={social.icon}
                    alt={social.name}
                    className="w-6 h-6 object-contain opacity-60 group-hover:opacity-100 transition-opacity duration-500"
                  />
                  <span className="font-grotesk text-sm text-silver-400 group-hover:text-champagne-300 transition-colors duration-500">
                    {social.name}
                  </span>
                  <span
                    className="ml-auto text-champagne-500 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500"
                    aria-hidden="true"
                  >
                    →
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-24 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-silver-600 tracking-wide">
          © {new Date().getFullYear()} Sagar Khatri. All rights reserved.
        </p>
        <p className="text-xs text-silver-600 tracking-wide">
          Crafted with precision · India
        </p>
      </div>
    </div>
  );
};

export default Contact;